import useWindowSize from 'components/draw/hooks/useWindowSize'

export default function useIsMobile(width = 501) {
  const windowSize = useWindowSize()

  return windowSize.width < width
}
